/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [

    {
        field: 'weekBuild',
        headerName: 'Order Build Week',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === 0 ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    }
];

const CheckOrdersOrderSummaryTable = props => (

    <section className="atp-search-result-panel check-orders-order-summary-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

CheckOrdersOrderSummaryTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default CheckOrdersOrderSummaryTable;
